var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.totalNumber > 0 ? _c("span", [_vm._v(" " + _vm._s((_vm.currentPage == 0 ? _vm.currentPage : _vm.currentPage - 1) * _vm.limits + 1) + " to " + _vm._s((_vm.currentPage - 1) * _vm.limits + _vm.limits >= _vm.totalNumber ? _vm.totalNumber : (_vm.currentPage - 1) * _vm.limits + _vm.limits) + " of " + _vm._s(_vm.totalNumber) + " element" + _vm._s(_vm.totalNumber > 1 ? "s" : null) + " ")]) : _c("span", [_vm._v("No element")])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };